import callApi from './callApi';

const token = localStorage.getItem('token');

export const loginUser = async (user) => {
  let url = 'users/signin';
  let headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'POST', body);
};

export const createUser = async (user) => {
  const url = 'users';
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'POST', body);
};

export const searchUsers = async (filterName, pageSize, page, token) => {
  const url = `users?name=${filterName}&pageSize=${pageSize}&page=${page}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, 'GET');
};

export const fetchCurrentUser = async (token) => {
  const url = `users/current_user`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, 'GET');
};

export const editUserByAdmin = async (id, user, token) => {
  let url = `users/${id}`;
  let headers = {
    Authorization: `${token}`,
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'PUT', body);
};


export const editCurrentUser = async (user) => {
  let url = `users`;
  let headers = {
    Authorization: `${token}`,
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'PUT', body);
};

//check if token needed

export const resetPassword = async (user) => {
  let url = `users/password`;
  let headers = {
    Authorization: `${token}`,
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'PUT', body);
};


export const listAllUsers = async (page, pageSize, token, filterName, userType) => {
  const url = `users?pageSize=${pageSize}&page=${page}&name=${filterName ? filterName : ''}&userType=${userType ? userType : ''}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, 'GET');
};

export const listAllUsersByType = async (userType, token) => {
  const url = `users?userType=${userType}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, 'GET');
};

export const forgotPassword = async (user) => {
  let url = `users/password`;
  let headers = {
    Authorization: `${token}`,
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'POST', body);
};

export const getLogs = async (token, pageSize, page, searchTerm) => {
  const url = `logs?pageSize=${pageSize}&pageNo=${page}&searchTerm=${searchTerm}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, 'GET');
};

export const getTags = async (token) => {
  const url = `tags/affiliatetags`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, 'GET');
};